import { combineReducers } from 'redux';
import loadCreatePreparationError from './loadCreatePreparationError';
import createSiteError from './createSiteError';
import editSiteError from './editSiteError';

export default combineReducers({
  loadCreatePreparationError,
  editSiteError,
  createSiteError,
});
